import * as THREE from 'three'

export const webPositions = [
  {
    key: '001',
    numbers: [0.1, 5, -19.9],
    vector: new THREE.Vector3(0.1, 5, -19.9),
    showFrame: true,
  },
  {
    key: '002',
    numbers: [45.1, 5, -19.9],
    vector: new THREE.Vector3(45.1, 5, -19.9),
    showFrame: true,
  },
  {
    key: '003',
    numbers: [22.6, 5, -19.9],
    vector: new THREE.Vector3(65.1, 5, -19.9),
    showFrame: true,
  },
  {
    key: '004',
    numbers: [22.6, 5, 24.9],
    vector: new THREE.Vector3(65.1, 15, 45),
    isPng: true,
    backWall: true,
    showFrame: false,
    size: [2244 / 150, 1534 / 150, 1],
    transparent: true,
  },
]
